// 防抖函数
export function debounce (fun, delay) {
  let timer = null
  return () => {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(fun, delay)
  }
}



// WEBPACK FOOTER //
// ./src/utils/debounce.js